import React, { useEffect } from "react";
import "./ImageList.css";

const ImageList = ({ images, autoscroll = false, innerRef }) => {
  function format(image, index) {
    // console.log(image);

    return (
      <img key={index} src={image.src} alt={image.alt} className="image" />
    );
  }

  useEffect(() => {
    if (autoscroll) {
      const interval = window.setInterval(function () {
        const carousel = document.getElementById("carousel");
        const carouselScrollWidth = carousel.scrollWidth;
        if (carousel.scrollLeft !== carouselScrollWidth) {
          carousel.scrollTo(carousel.scrollLeft + 5, 0);
        }
      }, 15);
      return () => clearInterval(interval);
    }
  }, [autoscroll]);
  return (
    <div id="carousel" className="container" ref={innerRef}>
      {images.map((image, index) => format(image, index))}
    </div>
  );
};

export default ImageList;
